import React, { useContext, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import HeaderAr from '../components/HeaderAr';
import Footer from '../components/Footer';
import FooterAr from '../components/FooterAr';
import { LanguageContext } from '../components/LanguageContext';
import './MainLayout.css';

const MainLayout = () => {
  const location = useLocation();
  const isArabic = location.pathname.startsWith('/ar');
  const { changeLanguage } = useContext(LanguageContext);

  useEffect(() => {
    if (changeLanguage) {
      changeLanguage(isArabic ? 'ar' : 'en');
    }
  }, [isArabic, changeLanguage]);

  return (
    <div className="main-layout">
      {isArabic ? <HeaderAr /> : <Header />}
      <main className="main-content">
        <Outlet />
      </main>
      {isArabic ? <FooterAr /> : <Footer />}
    </div>
  );
};

export default MainLayout; 